module.exports = __webpack_public_path__ + "static/media/green-check.46457197.svg";